(function(){
  function initSig(root){
    var section = root.querySelector('[data-vp-sig]');
    if(!section || section.dataset.vpInit) return;
    section.dataset.vpInit = '1';

    /* The showcase video is rendered without autoplay so the page does not
       fetch it up front; it plays, muted and looping, only while the stage
       is on or near the screen. */
    var video = section.querySelector('video');
    if(video && 'IntersectionObserver' in window){
      var vio = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(entry.isIntersecting){
            if(video.preload === 'none') video.preload = 'auto';
            var p = video.play(); if(p && p.catch) p.catch(function(){});
          } else if(!video.paused){
            video.pause();
          }
        });
      }, {rootMargin:'300px 0px'});
      vio.observe(video);
    } else if(video){
      var p0 = video.play(); if(p0 && p0.catch) p0.catch(function(){});
    }

    var targets = section.querySelectorAll('.vp-reveal');
    if(!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches){
      targets.forEach(function(el){ el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, {threshold:0, rootMargin:'0px 0px -8% 0px'});
    targets.forEach(function(el){ io.observe(el); });

    setTimeout(function(){ targets.forEach(function(el){ el.classList.add('in'); }); }, 3800);
  }
  function boot(){ initSig(document); }
  if(document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function(e){ initSig(e.target); });
})();